export default __webpack_public_path__ + "static/heart-health-box@2x-fe80473e87b8eb63042b8d1bad98562d.png";